import { request } from "@playwright/test";
import { client } from "./../../../shogun/archive/src-dist/eLearning-backend/coursecompletions/services.gen";
import {
  ProcessMiningClient,
  SchedulerClient,
  TwinManagementClient,
  DashboardBuilderClient,
  MaintenanceClient,
  TwinReportingClient,
} from "@inctec/smx-ui-client";
import { Interceptors } from "../../../shogun/archive/src-dist/eLearning-ui/accounts/core/OpenAPI";
import axios, { InternalAxiosRequestConfig } from "axios";

export function initClients({
  requestInterceptors,
  responseInterceptors,
}: {
  requestInterceptors?: {
    onFulfilled: (
      value: InternalAxiosRequestConfig,
    ) => InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig>;
    onRejected?: (error: any) => any;
  }[];
  responseInterceptors?: {
    onFulfilled: (value: any) => any;
    onRejected?: (error: any) => any;
  }[];
}) {
  ProcessMiningClient.setConfig({
    baseURL: "/api/process-mining",
    throwOnError: true,
  });

  SchedulerClient.setConfig({
    baseURL: "/api/scheduler",
    throwOnError: true,
  });

  TwinManagementClient.setConfig({
    baseURL: "/api/",
    throwOnError: true,
  });

  TwinReportingClient.setConfig({
    baseURL: "/api/",
    throwOnError: true,
  });

  DashboardBuilderClient.setConfig({
    baseURL: "/api/portal",
    throwOnError: true,
  });

  MaintenanceClient.setConfig({
    // NOTE: /tm is maintained in the spec for this endpoint
    baseURL: "/api/",
    throwOnError: true,
  });

  requestInterceptors?.forEach((interceptor) => {
    axios.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    ProcessMiningClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    DashboardBuilderClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    TwinManagementClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    TwinReportingClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    SchedulerClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    MaintenanceClient.instance.interceptors.request.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
  });
  responseInterceptors?.forEach((interceptor) => {
    axios.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    ProcessMiningClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    DashboardBuilderClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    TwinManagementClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    TwinReportingClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    SchedulerClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
    MaintenanceClient.instance.interceptors.response.use(
      interceptor.onFulfilled,
      interceptor.onRejected,
    );
  });
}
